// Exact dates, never relative (D-013): "Sep 25, 2026". Input is a plain YYYY-MM-DD date.
export function prettyDate(iso) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00Z`);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

const DAY_MS = 24 * 60 * 60 * 1000;
export const isOpen = (postExpiry) => !postExpiry || Date.parse(`${postExpiry}T00:00:00Z`) + DAY_MS >= Date.now();
// Posted in the last 3 days.
export const isNew = (postedOn) => Boolean(postedOn) && Date.now() - Date.parse(`${String(postedOn).slice(0, 10)}T00:00:00Z`) < 3 * DAY_MS;

// Owner 2026-10-02: our own postings with no job type show "Full-time". External listings come
// from the employer's site, so an unknown type stays blank there rather than guessing.
export const jobType = (categories, external = false) => String(categories || '').trim() || (external ? '' : 'Full-time');
